import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

import type { MeetingNotesAutomationDiscoveryProps } from './MeetingNotesAutomationDiscovery.tsx';

export const LazyMeetingNotesAutomationDiscovery: LoadableType<MeetingNotesAutomationDiscoveryProps> =
	LoadableLazy({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-MeetingNotesAutomationDiscovery" */ './MeetingNotesAutomationDiscovery.tsx'
				)
			).MeetingNotesAutomationDiscovery,
	});
